import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, Thumbs, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
Swiper.use([Navigation, Pagination, Autoplay, Thumbs, EffectFade]);

jQuery(document).ready(function () {
    if (jQuery(".page-header-carousel").length) {
        machPageHeadersSwiper();
    }

    if (jQuery(".carousel-square-images .swiper").length) {
        machSquareImagesSwiper();
    }

    if (jQuery(".carousel-teaser-boxes .swiper").length) {
        machTeaserBoxesSwiper();
    }

    if (jQuery(".carousel-promotions .swiper").length) {
        machPromotionsBoxesSwiper();
    }

    if (jQuery(".horizontal-toggle-list .swiper").length) {
        machHorizontalToggleListSwiper();
        jQuery(".horizontal-toggle-list.toggles .toggle-link").on("click", machHorizontalToggleChangeContent);
    }

    if (jQuery(".carousel-pictures .main-swiper").length) {
        machPicturesCarouselSwiper();
        jQuery(".slider-thumbnails a").on("click", machPicturesCarouselThumnailsChangeSlide);
    }

    if (jQuery(".carousel-banner-images .swiper").length) {
        machBannerImagesCarouselSwiper();
    }
});

function machPageHeadersSwiper() {
    let $pageCarouselContainer = jQuery(".page-header-carousel");

    let swiperPageHeader = new Swiper(".page-header-carousel", {
        slidesPerView: 1,
        effect: "fade",
        autoHeight: true,
        spaceBetween: 0,
        autoplay: {
            delay: 10000,
            // pauseOnMouseEnter: true,
        },
        lazy: true,
        speed: 400,
        loop: true,
        pagination: {
            el: ".slider-pagination",
            bulletClass: "slider-pagination-bullet",
            type: "custom",
            clickable: true,
            // Define our custom pagination elements
            renderCustom: function (swiper, current, total) {
                let paginationHtml = "";
                for (let i = 0; i < total; i++) {
                    let bulletClass = "";

                    if (i === current - 1) {
                        bulletClass += " current";
                    }

                    if (i < current - 1) {
                        bulletClass += " full";
                    }

                    paginationHtml +=
                        '<a href="#" data-pagination-index="' + i + '" class="slider-pagination-bullet ' + bulletClass + '"><span><span></span></span></a>';
                }
                return paginationHtml;
            },
        },
        on: {
            // Set the fraction pagination
            activeIndexChange: function () {
                $pageCarouselContainer
                    .find(".slider-fraction")
                    .html(
                        "<span>" + (this.realIndex + 1).toString().padStart(2, "0") + "</span>&nbsp;/&nbsp;" + this.slides.length.toString().padStart(2, "0")
                    );
            },
        },
    });

    const slideChangeBgColor = function () {
        let currentSlide = this.visibleSlides[0];
        if (currentSlide) {
            // @todo: check if the user has scrolled enough
            jQuery(".main-header-bg").css("--header-bg-color", jQuery(currentSlide).data("zone-color"));
            jQuery(".main-header-bg").css("--header-bg-opacity", jQuery(currentSlide).data("zone-opacity"));
        }
    };

    // Change the header background color when a slide is changed
    swiperPageHeader.on("realIndexChange", slideChangeBgColor);
    swiperPageHeader.on("slideChange", slideChangeBgColor);

    // Change the width of the pagination bars
    swiperPageHeader.on("autoplayTimeLeft", function (s, time, progress) {
        let percentage = 100 - progress * 100;
        $pageCarouselContainer.find("[data-pagination-index='" + this.realIndex + "'] span span").css("width", percentage + "%");
    });
}

function machSquareImagesSwiper() {
    jQuery(".carousel-square-images").each((index, element) => {
        let swiperSquareCarousel = new Swiper(jQuery(element).find(".swiper")[0], {
            grabCursor: true,
            navigation: {
                nextEl: jQuery(element).find(".swiper-next")[0],
                prevEl: jQuery(element).find(".swiper-prev")[0],
            },
            slidesPerView: 1.75,
            autoHeight: true,
            spaceBetween: 12,
            lazy: true,
            watchSlidesProgress: true,
            loop: false,
            breakpoints: {
                768: {
                    slidesPerView: 2.75,
                    spaceBetween: 20,
                },
                1130: {
                    slidesPerView: 3.75,
                    spaceBetween: 20,
                },
                2300: {
                    slidesPerView: 4.75,
                    spaceBetween: 20,
                },
            },
            on: {
                reachEnd: function () {
                    // Get the last slide element
                    var lastSlide = this.slides[this.slides.length - 1];

                    // Add a class to the last slide
                    lastSlide.classList.add("last-slide-active");
                },
            },
        });
    });
}

function machTeaserBoxesSwiper() {
    jQuery(".carousel-teaser-boxes").each((index, element) => {
        let swiperTeaserCarousel = new Swiper(jQuery(element).find(".swiper")[0], {
            grabCursor: true,
            navigation: {
                nextEl: jQuery(element).find(".swiper-next")[0],
                prevEl: jQuery(element).find(".swiper-prev")[0],
            },
            slidesPerView: 1.4,
            autoHeight: false,
            spaceBetween: 25,
            lazy: true,
            watchSlidesProgress: true,
            loop: false,
            breakpoints: {
                620: {
                    slidesPerView: 2.4,
                },
                1024: {
                    slidesPerView: 3,
                },
            },
        });
    });
}

function machPromotionsBoxesSwiper() {
    jQuery(".carousel-promotions").each((index, element) => {
        if (jQuery(element).hasClass("carousel-small-screen")) {
            // Disable the carousel on screens wider than 1024px
            if (window.innerWidth > 1024) {
                return false;
            }
        }
        let swiperPromotionsCarousel = new Swiper(jQuery(element).find(".swiper")[0], {
            grabCursor: true,
            navigation: {
                nextEl: jQuery(element).find(".swiper-next")[0],
                prevEl: jQuery(element).find(".swiper-prev")[0],
            },
            slidesPerView: 1.4,
            autoHeight: false,
            spaceBetween: 25,
            lazy: true,
            watchSlidesProgress: true,
            loop: false,
            breakpoints: {
                620: {
                    slidesPerView: 2.4,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                },
            },
        });
    });
}

function machBannerImagesCarouselSwiper() {
    jQuery(".carousel-banner-images").each((index, element) => {
        let swiperBannerImagesCarousel = new Swiper(jQuery(element).find(".swiper")[0], {
            navigation: {
                nextEl: jQuery(element).find(".swiper-next")[0],
                prevEl: jQuery(element).find(".swiper-prev")[0],
            },
            autoHeight: true,
            lazy: true,
            loop: true,
        });
    });
}

function machPicturesCarouselSwiper() {
    jQuery(".carousel-pictures").each((index, element) => {
        let swiperTextContent = new Swiper(jQuery(element).find(".details-swiper")[0], {
            slidesPerView: 1,
            autoHeight: true,
            spaceBetween: 0,
            loop: true,
        });

        let swiperPicturesCarousel = new Swiper(jQuery(element).find(".main-swiper")[0], {
            autoHeight: true,
            navigation: {
                nextEl: jQuery(element).find(".swiper-next")[0],
                prevEl: jQuery(element).find(".swiper-prev")[0],
            },
            centeredSlides: true,
            spaceBetween: 30,
            effect: "fade",
            lazy: true,
            loop: true,
            thumbs: {
                swiper: swiperTextContent,
            },
            on: {
                // Set the fraction pagination
                realIndexChange: function () {
                    machToggleCustomThumbnails(this);
                },
                // Set the fraction pagination
                init: function () {
                    machToggleCustomThumbnails(this);
                },
            },
        });

        function machToggleCustomThumbnails(swiper) {
            let realActiveIndex = swiper.realIndex; // Current active index
            let totalSlides = swiper.slides.length;
            let totalIndexes = totalSlides - 1;

            // Get previous two slides
            let prevSlidesIndex = [realActiveIndex - 1];
            let nextSlidesIndex = [realActiveIndex + 1];

            if (totalSlides == 1) {
                nextSlidesIndex = [];
                prevSlidesIndex = [];
            }

            if (totalSlides < 3) {
                nextSlidesIndex = [];
            }

            if (totalSlides > 3) {
                prevSlidesIndex.push(realActiveIndex - 2);
                nextSlidesIndex.push(realActiveIndex + 2);
            }

            prevSlidesIndex = prevSlidesIndex.map((index) => (index < 0 ? totalSlides + index : index));
            nextSlidesIndex = nextSlidesIndex.map((index) => (index > totalIndexes ? index - totalSlides : index));

            jQuery(element).find(".slider-thumbnails a").hide();
            let order = prevSlidesIndex.length;
            prevSlidesIndex.forEach((index) => {
                jQuery(element)
                    .find(".left-thumbnails a[data-index='" + index + "']")
                    .show()
                    .css("order", order);
                order--;
            });
            order = 1;
            nextSlidesIndex.forEach((index) => {
                jQuery(element)
                    .find(".right-thumbnails a[data-index='" + index + "']")
                    .show()
                    .css("order", order);
                order++;
            });
        }
    });
}

function machHorizontalToggleListSwiper(e) {
    jQuery(".horizontal-toggle-list").each((index, element) => {
        let swiper = new Swiper(jQuery(element).find(".swiper")[0], {
            slidesPerView: "auto",
            freeMode: true,
            spaceBetween: 0,
            centerInsufficientSlides: true,
            grabCursor: true,
            pagination: {
                el: jQuery(element).find(".swiper-pagination")[0],
                type: "progressbar",
            },
        });
    });
}

function machPicturesCarouselThumnailsChangeSlide(e) {
    e.preventDefault();
    let $carousel = jQuery(this).parents(".carousel-pictures").find(".swiper");
    if ($carousel) {
        $carousel[0].swiper.slideToLoop(jQuery(this).data("index"));
    }
}

function machHorizontalToggleChangeContent(e) {
    e.preventDefault();
    let $toggle = jQuery(this);
    let $toggleWrapper = $toggle.parents(".toggle-wrapper");
    let toggleIndex = $toggle.data("toggle-index");
    let $toggleList = $toggle.parents(".horizontal-toggle-list");

    $toggleList.find(".toggle-link").removeClass("active");
    $toggle.addClass("active");

    $toggleWrapper.find(".toggle-content").hide();
    $toggleWrapper.find('[data-toggle-index="' + toggleIndex + '"]').show();
}
